import { render, staticRenderFns } from "./YuePuJieYue.vue?vue&type=template&id=262852c4&scoped=true&"
import script from "./YuePuJieYue.vue?vue&type=script&lang=js&"
export * from "./YuePuJieYue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262852c4",
  null
  
)

export default component.exports